import React from "react";
import { GridContainer, GridRow, GridColumn } from "arv-reactcomponents";
import Banner from "../Banner";
import { CORPORATE_GIFTING_COMPONENTS } from "npmlinks-constants";

const GiftingEnquiry = () => {
  const stateCenterObj = JSON.parse(
    CORPORATE_GIFTING_COMPONENTS.GIFTINGENQUIRY_STATEWISE,
  );
  const stateCenterArray = stateCenterObj.stateCenter;
  const otherQueriesObj = JSON.parse(
    CORPORATE_GIFTING_COMPONENTS.GIFTINGENQUIRY_QUERIES,
  );
  const otherQueriesArray = otherQueriesObj.queries;
  return (
    <GridContainer>
      <GridRow className="wc-giftingenquiry-subcontainer">
        <Banner
          text={CORPORATE_GIFTING_COMPONENTS.GIFTINGENQUIRY_SUBHEADING}
          className="wc-giftingenquiry-banner"
        />
      </GridRow>

      <GridRow className="wc-giftingenquiry-subcontainer">
        {stateCenterArray &&
          stateCenterArray.map(object => (
            <GridColumn className="nwc-grid-col-sm-3">
              <div className="wc-giftingenquiry-details">
                <div className="wc-giftingenquiry-subtitle">{object.title}</div>
                <div className="wc-giftingenquiry-data">
                  {object.contactperson}
                </div>
                <div className="wc-giftingenquiry-data">{object.contactno}</div>
                <div className="wc-giftingenquiry-data">{object.email}</div>
              </div>
            </GridColumn>
          ))}
        {otherQueriesArray.map(object => (
          <GridColumn className="nwc-grid-col-sm-3">
            <div className="wc-giftingenquiry-details">
              <div className="wc-giftingenquiry-subtitle">{object.title}</div>
              {object.subpoints.map(obj => (
                <div className="wc-giftingenquiry-data">{obj}</div>
              ))}
            </div>
          </GridColumn>
        ))}
      </GridRow>
    </GridContainer>
  );
};
export default GiftingEnquiry;
